import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { UserX } from 'lucide-react';

const COLORS = ['#9CA3AF', '#F59E0B', '#EF4444', '#A78BFA', '#38BDF8'];

export const LostReasonsSummary = ({ isAdmin }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/dashboard/lost-reasons').then(setData).catch(() => {}); }, []);
  if (!data) return null;
  const since = new Date(data.since).toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div data-testid="lost-reasons-summary" className="bg-[#0A1F1A] rounded-2xl border border-white/5 p-5 lg:p-6">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h2 className="font-outfit text-base lg:text-lg font-medium text-white flex items-center gap-2">
            <UserX size={18} strokeWidth={1.5} className="text-red-400" /> Leads perdidos por motivo
          </h2>
          <p className="text-xs text-white/40 mt-1">{isAdmin ? 'Todo el equipo' : 'Tus leads'} · desde el {since}</p>
        </div>
        <p className="text-right"><span data-testid="lost-reasons-total" className="font-outfit text-2xl font-semibold text-white tabular-nums">{data.total}</span>
          <span className="block text-[10px] uppercase tracking-wider text-white/40">perdidos</span></p>
      </div>
      <div className="space-y-3">
        {data.reasons.map((r, i) => {
          const pct = data.total ? Math.round((r.count * 100) / data.total) : 0;
          return (
            <div key={r.reason} data-testid={`lost-reason-${i}`}>
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="text-white/80">{r.reason}</span>
                <span className="text-white tabular-nums">{r.count} <span className="text-white/30 text-xs">({pct}%)</span></span>
              </div>
              <div className="h-2 rounded-full bg-white/5 overflow-hidden">
                <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct}%`, backgroundColor: COLORS[i % COLORS.length] }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
